<template>
    <v-card>
        <v-card-title style="background-color: #2b3990" class="white--text pa-4">
            <span class="headline">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-form
                    ref="form"
                    lazy-validation
                >
                    <v-row>
                        <v-col class="d-flex" cols="12" md="5">
                            <v-row>
                                <v-col cols="12" lg="12" md="12">
                                    <DatePicker
                                        v-model="startShiftDate"
                                        label="Start Shift"
                                    />
                                    <TimePicker
                                        v-model="startShiftTime"
                                        labelHour="Start Shift Hour"
                                        labelMinute="Start Shift Minute"
                                    />
                                </v-col>
                                <v-col cols="12" lg="12" md="12">
                                    <DatePicker
                                        label="End Shift"
                                        v-model="endShiftDate"
                                    />
                                    <TimePicker
                                        v-model="endShiftTime"
                                        labelHour="End Shift Hour"
                                        labelMinute="End Shift Minute"
                                    />
                                </v-col>
                                <v-container fluid>
                                    <p>Recurring Events?</p>
                                    <v-radio-group v-model="isRecurringEvent" mandatory>
                                        <v-radio label="Yes" value="Yes"></v-radio>
                                        <v-radio label="No" value="No"></v-radio>
                                    </v-radio-group>
                                </v-container>
                                <!--
                                <v-col cols="6" sm="12" md="6" v-if="isRecurringEvent == 'Yes'">
                                    <v-menu
                                        ref="calendarMenu"
                                        v-model="calendarMenu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="startDateOfRecurringEvent"
                                                label="Start Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                clearable
                                                @change="getAttendance()"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="startDateOfRecurringEvent"
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="calendarMenu = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.calendarMenu.save(date)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="6" sm="12" md="6" v-if="isRecurringEvent == 'Yes'">
                                    <v-menu
                                        ref="calendar2Menu"
                                        v-model="calendar2Menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="endDateOfRecurringEvent"
                                                label="End Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                clearable
                                                @change="getAttendance()"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="endDateOfRecurringEvent"
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="calendar2Menu = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.calendar2Menu.save(date)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                -->
                                <v-col cols="12" sm="12" md="6" v-if="isRecurringEvent === 'Yes'">
                                    <v-select
                                        :items="optionsForRecurring"
                                        label="More"
                                        v-model="selectedOption"
                                        outlined
                                    ></v-select>
                                </v-col>

                                <v-container fluid>
                                    <p>Is this for a training?</p>
                                    <v-radio-group v-model="isForTraining" mandatory>
                                        <v-radio label="Yes" value="Yes"></v-radio>
                                        <v-radio label="No" value="No"></v-radio>
                                    </v-radio-group>
                                </v-container>

                                <!--
                                <v-col class="d-flex" cols="12" sm="12" >
                                    <v-autocomplete
                                    v-model="StaffId"
                                    :items="staff"
                                    item-text="Name"
                                    item-value="_id"
                                    label="Staff"
                                    required
                                    :error-messages="staffErrors"
                                    @input="$v.StaffId.$touch()"
                                    @blur="$v.StaffId.$touch()"
                                    ></v-autocomplete>
                                </v-col>
                                -->
                                <v-col class="d-flex" cols="12" md="12">
                                    <v-autocomplete
                                        :key="componentKey"
                                        v-model="HouseName"
                                        :items="houses"
                                        item-text="Name"
                                        item-value="Name"
                                        label="Program"
                                        required
                                        :error-messages="houseErrors"
                                        @input="$v.HouseName.$touch()"
                                        @blur="$v.HouseName.$touch()"
                                        @change="getClientsByUnit()"
                                    ></v-autocomplete>
                                </v-col>

                                <v-col class="d-flex" cols="12" md="12">
                                    <v-select
                                        :items="clientsUnderSelectedProgram"
                                        item-text="Name"
                                        item-value="_id"
                                        label="Client(s)"
                                        v-model="ClientId"
                                        multiple
                                        required
                                        :error-messages="clientErrors"
                                        @input="$v.ClientId.$touch()"
                                        @blur="$v.ClientId.$touch()"
                                        @change="getTasks()"
                                    />
                                    <!--
                                    <v-autocomplete
                                        v-model="ClientId"
                                        :items="clients"
                                        item-text="Name"
                                        item-value="_id"
                                        label="Client"
                                    ></v-autocomplete>
                                    -->
                                </v-col>

                                <v-col class="d-flex" cols="12" md="12" v-if="isForTraining === 'No'">
                                  <v-select
                                      :items="serviceCodes"
                                      item-text="Name"
                                      item-value="_id"
                                      label="Service Code"
                                      v-model="ServiceCode"
                                      required
                                      :error-messages="ServiceCodeErrors"
                                      @input="$v.ServiceCode.$touch()"
                                      @blur="$v.ServiceCode.$touch()"
                                  />
                                  <!--
                                  <v-autocomplete
                                      v-model="ClientId"
                                      :items="clients"
                                      item-text="Name"
                                      item-value="_id"
                                      label="Client"
                                  ></v-autocomplete>
                                  -->
                                </v-col>

                                <v-col cols="12" md="12">
                                    <v-textarea v-model="notes" outlined label="Notes" value=""></v-textarea>
                                </v-col>

                            </v-row>
                        </v-col>
                        <v-col class="d-flex" cols="12" md="3">
                            <v-col cols="12" md="12">
                                <v-radio-group v-model="task">
                                    <template v-slot:label>
                                        <h3 class="text-center">Assign Task</h3>
                                    </template>
                                    <div v-for="task in tasks" :key="task._id">
                                        <v-radio :value="task.Event">
                                            <template v-slot:label>
                                                <div>{{ task.Event }}</div>
                                            </template>
                                        </v-radio>
                                    </div>
                                </v-radio-group>
                            </v-col>
                        </v-col>
                        <v-col class="d-flex" cols="12" md="4" style="">
                            <!--PUT THE ADDITIONAL INFORMATION--->
                            <v-row>
                                <v-col cols="12" md="12">
                                    <!-- Time off Request through {{startDateTime}} - {{endDateTime}} -->
                                    <v-expansion-panels v-if="timeOff" flat>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                Time off Requests ({{requests.length}})
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>

                                                <v-list two line>
                                                    <v-list-item-group
                                                        v-model="selected"
                                                    >
                                                        <template>
                                                            <v-list-item v-for="request in requests" :key="request._id" width="90">
                                                                <template>

                                                                        <v-list-item-content>
                                                                            <v-list-item-title class="font-weight-bold">
                                                                                {{ request.StaffID.Name }}

                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle class="text--primary">
                                                                                {{ request.Reason }}

                                                                            </v-list-item-subtitle>
                                                                            <v-list-item-subtitle class="text--primary">
                                                                                {{ request.StartDate }}
                                                                                {{ request.EndDate }}

                                                                            </v-list-item-subtitle>
                                                                        </v-list-item-content>

                                                                    <!-- <v-list-item-action>
                                                                        <v-btn
                                                                            color="grey lighten-1"
                                                                            x-small
                                                                        >
                                                                            Pending
                                                                        </v-btn>

                                                                        <v-btn
                                                                            class="ma-1"
                                                                            color="yellow darken-3"
                                                                            x-small
                                                                            @click="updateShifts"
                                                                        >
                                                                            Approve
                                                                        </v-btn>
                                                                        <v-btn
                                                                            class="ma-1"
                                                                            color="grey darken-3 white--text"
                                                                            x-small
                                                                            @click="updateShifts"
                                                                        >
                                                                            Deny
                                                                        </v-btn>
                                                                    </v-list-item-action> -->
                                                                </template>
                                                            </v-list-item>
                                                        </template>
                                                    </v-list-item-group>
                                                </v-list>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-skeleton-loader
                                        v-if="skeletonLoaderStaff"
                                        v-bind="skeletonLoaderStaffAttrs"
                                        type="heading, table-cell@4"
                                        class="mb-6 px-4 pt-5 overflow-y-auto" height="35vh"
                                    ></v-skeleton-loader>

                                    <v-card class="mb-6 px-4 pt-3 overflow-y-auto" height="35vh" v-if="skeletonLoaderStaff === false">
                                        <v-card-title >Available</v-card-title>
                                        <v-divider></v-divider>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            solo-inverted
                                            hide-details
                                            prepend-inner-icon="search"
                                            label="search"
                                            class="desktop"
                                        ></v-text-field>
                                        <v-spacer></v-spacer>
                                        <v-radio-group
                                            v-model="staffSelected"
                                            :rules="requiredField"
                                            required
                                            @change="checkSupervision"
                                        >
                                            <div v-for="available in resultQuery" :key="available._id">
                                                <v-radio :value="available" class="mb-2">
                                                    <template v-slot:label>
                                                        <div :style="{ color: available.RequiresSupervision ? 'red' : '' }">
                                                            {{ available.Name }}
                                                            <v-icon v-if="available.MedCertified" small>verified_user</v-icon>
                                                            <v-icon v-if="available.FirstAid" small>local_hospital</v-icon>
                                                            <v-icon small style="position: absolute; right: 0;">mdi-phone</v-icon>
                                                        </div>
                                                    </template>
                                                </v-radio>
                                            </div>
                                        </v-radio-group>
                                    </v-card>

                                    <v-skeleton-loader
                                        v-if="skeletonLoaderStaff"
                                        v-bind="skeletonLoaderStaffAttrs"
                                        type="heading, table-cell@4"
                                        class="px-4 pt-6 overflow-y-auto" height="35vh"
                                    ></v-skeleton-loader>

                                    <v-card class="overflow-y-auto" height="35vh" v-if="skeletonLoaderStaff === false">
                                        <v-list class="overflow-y-auto" height="40vh">
                                            <v-subheader>
                                                <h3>Schedule on this Date</h3>
                                            </v-subheader>
                                            <v-list-item
                                                v-for="(schedule, i) in scheduledStaff"
                                                :key="i"
                                                :value="schedule._id"
                                            >
                                                <v-list-item-title :style="{ color: schedule.RequiresSupervision ? 'red' : '' }" v-text="schedule.employee.Name"></v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>

                                <!-- <v-col cols="12" md="12" v-if="isForTraining == 'Yes'">
                                    <v-autocomplete
                                        class=""
                                        v-model="HouseName"
                                        :items="houses"
                                        item-text="Name"
                                        item-value="Name"
                                        label="Filter by Program"
                                        @input="$v.HouseName.$touch()"
                                        @blur="$v.HouseName.$touch()"
                                        @change="getClientsByUnit()"
                                    ></v-autocomplete>
                                    <v-card class="pa-4 overflow-y-auto" height="35vh">
                                        <v-card-title>Available</v-card-title>
                                        <v-divider></v-divider>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            solo-inverted
                                            hide-details
                                            prepend-inner-icon="search"
                                            label="search"
                                            class="desktop"
                                        ></v-text-field>
                                        <v-spacer></v-spacer>
                                        <div v-for="available in resultQuery" :key="available._id">
                                            <v-checkbox
                                                multiple
                                                v-model="staffSelectedForMeeting"
                                                :value="available._id"
                                                required
                                            >

                                                <template v-slot:label>
                                                    <div>{{ available.Name }}
                                                        <v-icon v-if="available.MedCertified" small>verified_user
                                                        </v-icon>
                                                        <v-icon v-if="available.FirstAid" small>local_hospital</v-icon>

                                                        <v-icon small style="position: absolute;right: 0;">mdi-phone
                                                        </v-icon>
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </div>
                                    </v-card>
                                    <hr>
                                    <v-card class="mt-3 pa-4 overflow-y-auto" height="35vh">
                                        <v-card-title>Schedule in this Date</v-card-title>
                                        <v-divider></v-divider>

                                        <v-radio-group v-model="staffSelected">
                                            <div v-for="schedule in scheduledStaff" :key="schedule._id">
                                                <v-radio
                                                    :value="schedule.employee._id"
                                                    disabled
                                                >
                                                    <template v-slot:label>
                                                        <div>{{ schedule.employee.Name }}
                                                            <v-icon small style="position: absolute;right: 0;">
                                                                mdi-phone
                                                            </v-icon>
                                                        </div>
                                                    </template>
                                                </v-radio>
                                            </div>
                                        </v-radio-group>
                                    </v-card>
                                </v-col> -->
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close(), reset()">Cancel</v-btn>
            <v-btn
                color="#2b3990"
                class="white--text"
                @click="addShift()"
                :loading="addShift_btn_loader"
                :disabled="addShift_btn_loader"
            >
                Save & Close
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import moment from "moment";
    import moment_timezone from 'moment-timezone'
    import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
    import TimePicker from "@/components/DateTimePickers/TimePicker.vue";

    const url = require("../../client_config/config").url;
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import DateTimeUtil from '../../../utils/date-time.util';
    import Swal from "sweetalert2";

    //const ShiftService = require('../../service/shift.service');

    export default {
        components: {TimePicker, DatePicker},
        props: {
            close: Function,
            titleForm: String,
            staff: Array,
            clients: Array,
            houses: Array,
        },

        mixins: [validationMixin],

        validations: {
            ClientId: {required},
            HouseName: {required},
            ServiceCode: {required},
        },

        data: () => ({
            isForTraining: "No",
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            isRecurringEvent: "No",
            calendarMenu: false,
            calendar2Menu: false,
            optionsForRecurring: ['Daily', 'Weekly', 'Monthly', 'Annually'],
            selectedOption: "",
            selected: "",
            msg: "",
            text: "",
            color: "success",
            StaffId: null,
            search: null,
            staffSelected: "",
            supervisorSelected: "",
            staffSelectedForMeeting: "",
            ClientId: "",
            HouseId: "",
            HouseName: "",
            ServiceCode: "",
            notes: "",
            task: "",
            clientsUnderSelectedProgram: [],
            requiredField: [
                v => !!v || 'This is required',
            ],
            startDatetime: null,
            startDateOfRecurringEvent: "",
            endDatetime: null,
            endDateOfRecurringEvent: "",
            requests: [],
            timeOff: false,
            textFieldProps: {
                appendIcon: "event"
            },
            startDateProps: {
                min: moment(new Date()).format("YYYY-MM-DD")
            },
            startTimeProps: {
                ampmInTitle: true
            },
            endDateProps: { },
            endTimeProps: {},
            availableStaff: [],
            availableStaffForMeeting: [],
            scheduledStaff: [],
            isShowing: true,
            tasks: [],
            serviceCodes: [],

            addShift_btn_loader: false,
            userState: localStorage.getItem("userState"),

            skeletonLoaderStaff: true,
            skeletonLoaderStaffAttrs: {
                class: '',
                boilerplate: true,
                elevation: 2,
            },
            startShiftDate: '',
            startShiftTime: '',
            endShiftDate: '',
            endShiftTime: '',
            componentKey: 0
        }),

        async created() {
            this.checkRequests();
            // this.getStaffForMeeting(this.startDatetime, this.endDatetime);
        },

        async mounted () {
            this.$refs.form.resetValidation();
        },

        computed: {
            /*
            staffErrors () {
              const errors = []
              if (!this.$v.StaffId.$dirty) return errors
              !this.$v.StaffId.required && errors.push('Staff is required')
              return errors
            },*/
            houseErrors() {
                const errors = []
                if (!this.$v.HouseName.$dirty) return errors
                !this.$v.HouseName.required && errors.push('House/Unit is required')
                return errors
            },
            clientErrors() {
                const errors = []
                if (!this.$v.ClientId.$dirty) return errors
                !this.$v.ClientId.required && errors.push('Client is required')
                return errors
            },
            ServiceCodeErrors() {
                const errors = []
                if (!this.$v.ServiceCode.$dirty && this.serviceCodes.length > 0) return errors
                if (!this.$v.ServiceCode.required && this.serviceCodes.length > 0) {
                    errors.push('Service is required')
                }
                return errors
            },
            resultQuery() {
                if (this.search) {
                    return this.availableStaff.filter((item) => {
                        return this.search.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
                    })
                } else {
                    return this.availableStaff;
                }
            },
        },

        watch: {
            isForTraining (val) {
                if (val === "Yes") this.ServiceCode = "";
            }
        },

        methods: {
            showSuccessNotification(message) {
                this.msg = true;
                this.text = message;
                this.color = 'success';

                let emitValue = {msg: this.msg, text: this.text, color: this.color};
                this.$emit('successMessage', emitValue);
            },

            showErrorNotification(message) {
                this.msg = true;
                this.text = message;
                this.color = 'error';

                let emitValue = {msg: this.msg, text: this.text, color: this.color};
                this.addShift_btn_loader = false;
                this.$emit('errorMessage', emitValue);
            },

            async getDefaultStaff(start, end) {
                this.skeletonLoaderStaff = true;
                this.isShowing = false;
                let available = [];
                let schedule = [];

                const params = {
                    StartDate: start,
                    EndDate: end
                };

                await axios.get(`${url}/shifts/available/${this.HouseName}/${this.userState}`, {
                    params
                }).then(res => {
                    available = res.data.available;

                    if (res.data.schedule !== undefined) {
                        res.data.schedule.forEach(item => {
                            if (item.employee != null) {
                                if (item.employee.State === this.userState) {
                                    schedule.push(item);
                                }
                            }
                        })
                    }

                    schedule = [...new Map(schedule.map((item) => [item.employee._id, item])).values()];

                }).finally(() => {
                    this.isShowing = true;
                    this.availableStaff = available;
                    this.scheduledStaff = schedule;

                    this.skeletonLoaderStaff = false;
                });
            },

            async getStaffForMeeting(start, end) {
                this.isShowing = false;
                let available = [];
                let schedule = [];
                await axios.get(`${url}/shifts/available/${this.userState}`, {
                    params: {
                        StartDate: start,
                        EndDate: end
                    }
                }).then(res => {
                    available = res.data.available;
                    schedule = res.data.schedule;
                }).finally(() => {
                    schedule = schedule.filter(sched => {
                      if(sched.employee !== null){
                        return sched.employee.State == this.userState
                      }
                    })
                    this.isShowing = true;
                    this.availableStaff = available;
                    this.scheduledStaff = schedule;
                });
            },

            async getTasks() {
                // const startDate = moment().startOf('day').toISOString();
                // const endDate = moment().endOf('day').toISOString();
                this.getServiceCodes();

                let timezone = "";

                let startDate = moment_timezone.tz(moment().startOf('day').toISOString(), timezone)
                let endDate = moment_timezone.tz(moment().endOf('day').toISOString(), timezone)

                await axios.get(`${url}/calendar/tasks?startDate=${startDate}&endDate=${endDate}&client=${this.ClientId}`)
                    .then(response => {
                        this.tasks = response.data.tasks;
                    });



            },

            async getServiceCodes() {
              console.log(this.ClientId);
              this.serviceCodes = [];
              axios.get(`${url}/serviceCodes/client/${this.ClientId}`).then(res => {
                console.log(res.data.serviceCodes);
                this.serviceCodes = res.data.serviceCodes.map(item => {
                  return {
                    _id: item.Name,
                    Name: item.Name
                  }
                });
              });
            },

            async addShift() {
                this.addShift_btn_loader = true
                if (this.isForTraining === 'Yes') {
                    this.addScheduleShiftMeeting();
                } else if (this.isForTraining === 'No') {
                    if (this.$refs.form.validate()) {
                        this.addScheduleShift();
                    } else {
                        this.addShift_btn_loader = false
                        return;
                    }
                } else {
                    this.showErrorNotification('Please specify if this is for training or not.');
                }
            },

            async addScheduleShift() {
                if (!this.startShiftDate || !this.startShiftTime || !this.endShiftDate || !this.endShiftTime) {
                    this.showErrorNotification('Please provide shift start and end dates');
                    this.addShift_btn_loader = false;
                    return;
                }

                this.startDatetime = DateTimeUtil.toJSDate(`${this.startShiftDate} ${this.startShiftTime}`);
                this.endDatetime  = DateTimeUtil.toJSDate(`${this.endShiftDate} ${this.endShiftTime}`);

                // this.startDatetime = new Date(`${this.startShiftDate} ${this.startShiftTime}`);
                // this.endDatetime = new Date(`${this.endShiftDate} ${this.endShiftTime}`);

                if (moment(this.startDatetime).isSameOrAfter(this.endDatetime)) {
                    this.showErrorNotification('Shift start time should be before end time.');
                    this.addShift_btn_loader = false;
                    return;
                }

                const isRecurring = this.isRecurringEvent === 'Yes';

                if (isRecurring) {
                    const errorMessage = this.validateRecurringShift();

                    if (errorMessage) {
                        this.showErrorNotification(errorMessage);
                        return;
                    }

                    let recurringShiftDates = [];

                    if (this.selectedOption === 'Daily') {
                        recurringShiftDates = this.getRecurringDatesByUnit('days');
                    } else if (this.selectedOption === 'Weekly') {
                        recurringShiftDates = this.getRecurringDatesByUnit('weeks');
                    } else if (this.selectedOption === 'Monthly') {
                        recurringShiftDates = this.getRecurringDatesByUnit('months');
                    } else if (this.selectedOption === 'Annually') {
                        recurringShiftDates = this.getRecurringDatesByUnit('years');
                    }

                    console.log({recurringShiftDates});

                    const payload = {
                        currentUrl : window.location.href,
                        ClientId: this.ClientId,
                        EmployeeId: this.staffSelected,
                        HouseName: this.HouseName,
                        HouseId: this.HouseId,
                        StartDate: this.startDatetime.toISOString(),
                        EndDate: this.endDatetime.toISOString(),
                        Notes: this.notes,
                        Task: this.task,
                        isTraining: this.isForTraining,
                        isRecurringEvent : this.isRecurringEvent,
                        typeOfRecurringEvent: this.selectedOption,
                        endDateOfRecurringEvent: this.endDateOfRecurringEvent,
                        ServiceCode: this.ServiceCode,
                        tz: moment_timezone.tz.guess(),
                    };

                     if (!this.ClientId) {
                        this.msg = true;
                        this.text = ' Please select a Client/s';
                        this.color = "error";
                        let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true}
                        this.addShift_btn_loader = false;

                        this.$emit('addSchedule', emitValue);
                        return;
                    }
                    await axios
                        .post(`${url}/shifts`, payload)
                        .then(res => {
                            if (res) {
                                this.msg = true;
                                this.text = "Saved successfully.";
                                this.color = "success";
                                this.StaffId = 0;
                                this.ClientId = 0;
                                this.HouseId = 0;
                                this.ServiceCode = "";
                                this.HouseName = "";
                                this.notes = "";
                                this.tasks = "";
                                this.task = "";
                                this.selectedOption = "";
                                this.startDatetime = moment().toDate();
                                this.endDatetime = moment().add(8, 'hours').toDate();
                                let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: false}
                                this.addShift_btn_loader = false;

                                this.reset();
                                this.$refs.form.resetValidation();
                                this.$emit('addSchedule', emitValue);
                            }
                        })
                        .catch(async err => {
                            if (err.response) {
                                this.text = "Shift Already Exist";
                                this.msg = true;
                                this.color = "error";
                                let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true}
                                this.addShift_btn_loader = false;

                                this.$emit('addSchedule', emitValue);
                            }
                        });

                    // TODO: Refactor - Use bulk save instead of request loop
                    /*
                    recurringShiftDates.forEach(recurringShiftDate => {
                        const recurringShiftPayload = {
                            currentUrl : window.location.href,
                            ClientId: this.ClientId,
                            EmployeeId: this.staffSelected,
                            HouseName: this.HouseName,
                            HouseId: this.HouseId,
                            StartDate: recurringShiftDate.startDate,
                            EndDate: recurringShiftDate.endDate,
                            Notes: this.notes,
                            Task: this.task,
                            isTraining: this.isForTraining,
                            isRecurringEvent: this.isRecurringEvent,
                            typeOfRecurringEvent: this.selectedOption,
                            startDateOfRecurringEvent: this.startDateOfRecurringEvent,
                            endDateOfRecurringEvent: this.endDateOfRecurringEvent,
                        };

                        ShiftService.create(recurringShiftPayload).then(response => {
                            console.log({response});
                            this.msg = true;
                            this.text = "Saved successfully.";
                            this.color = "success";
                            this.StaffId = 0;
                            this.ClientId = 0;
                            this.HouseId = 0;
                            this.HouseName = "";
                            this.notes = "";
                            this.startDatetime = moment().toDate();
                            this.endDatetime = moment().add(8, 'hours').toDate();
                            let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: false};
                            this.$emit('addSchedule', emitValue);
                        }).catch(error => {
                            console.log({error});
                            this.text = "Fill Up All Required Fields";
                            this.msg = true;
                            this.color = "error";
                            let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true};
                            this.$emit('addSchedule', emitValue);
                        });
                    });
                    */
                } else {
                    this.$v.$touch();

                    if (this.$v.HouseName.$invalid) {
                        this.showErrorNotification("Please select Program");
                        return false;
                    }

                    if (this.$v.ClientId.$invalid) {
                        this.showErrorNotification("Please select Client");
                        return false;
                    }

                    if (this.$v.ServiceCode.$invalid) {
                        // Check if selected client has service code before going to save.
                        if (this.serviceCodes.length > 0) {
                            this.msg = true;
                            this.text = "Fill up all required fields";
                            this.color = "error";
                            this.addShift_btn_loader = false;
                            return false;
                        }

                    }

                    if(!this.staffSelected){
                        console.log("staff not selected");
                        this.showErrorNotification("Please select available Staff");
                        return false;
                    }

                    const payload = {
                        currentUrl : window.location.href,
                        ClientId: this.ClientId,
                        EmployeeId: this.staffSelected,
                        HouseName: this.HouseName,
                        HouseId: this.HouseId,
                        StartDate: this.startDatetime.toISOString(),
                        EndDate: this.endDatetime.toISOString(),
                        Notes: this.notes,
                        Task: this.task,
                        isTraining: this.isForTraining,
                        isRecurringEvent : this.isRecurringEvent,
                        typeOfRecurringEvent: this.selectedOption,
                        startDateOfRecurringEvent: this.startDateOfRecurringEvent,
                        endDateOfRecurringEvent: this.endDateOfRecurringEvent,
                        ServiceCode: this.ServiceCode,
                        tz: moment_timezone.tz.guess(),
                    };

                    if (!this.ClientId) {
                        this.msg = true;
                        this.text = ' Please select a Client/s';
                        this.color = "error";
                        let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true}
                        this.addShift_btn_loader = false;

                        this.$emit('addSchedule', emitValue);
                        return;
                    }
                    await axios
                        .post(`${url}/shifts`, payload)
                        .then(res => {
                            if (res) {
                                this.msg = true;
                                this.text = "Saved successfully.";
                                this.color = "success";
                                this.StaffId = 0;
                                this.ClientId = 0;
                                this.HouseId = 0;
                                this.ServiceCode = "";
                                this.HouseName = "";
                                this.notes = "";
                                this.tasks = "";
                                this.task = "";
                                this.startDatetime = moment().toDate();
                                this.endDatetime = moment().add(8, 'hours').toDate();
                                let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: false}
                                this.addShift_btn_loader = false;

                                this.selectedOption = "";
                                this.isRecurring = true;
                                this.reset();
                                this.$refs.form.resetValidation();
                                this.$emit('addSchedule', emitValue);
                            }
                        })
                        .catch(async err => {
                            if (err.response) {
                                this.text = "Shift Already Exist";
                                this.msg = true;
                                this.color = "error";
                                let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true}
                                this.addShift_btn_loader = false;

                                this.$emit('addSchedule', emitValue);
                            }
                        });
                }
            },

            validateRecurringShift() {
                if (!this.startDatetime) {
                    this.addShift_btn_loader = false;
                    return 'Start shift is required.';
                }

                if (!this.endDatetime) {
                    this.addShift_btn_loader = false;
                    return 'End shift is required.';
                }

                /*
                if (!this.startDateOfRecurringEvent) {
                    return 'Recurring start date is required.';
                }

                if (!this.endDateOfRecurringEvent) {
                    return 'Recurring end date is required.';
                }
                */

                if (!this.selectedOption) {
                    return 'Recurring option is required.';
                }

                return '';
            },

            getRecurringDatesByUnit(unit) {
                // TODO: Remove loggers once done
                const info = {
                    startDatetime: this.startDatetime,
                    endDatetime: this.endDatetime,
                    recurring: this.isRecurringEvent,
                    startDateOfRecurringEvent: this.startDateOfRecurringEvent,
                    endDateOfRecurringEvent: this.endDateOfRecurringEvent,
                    selectedOption: this.selectedOption
                };
                console.log({info});

                if (!unit) {
                    return [];
                }

                let recurringDates = [];

                const startAndEndDateTimeDifference = moment(this.endDatetime).diff(moment(this.startDatetime));
                const startAndEndDateTimeDuration = moment.duration(startAndEndDateTimeDifference);
                const startAndEndDateTimeDifferenceInMinutes = startAndEndDateTimeDuration.asMinutes();

                const startDateOfRecurringShift = new Date(this.startDateOfRecurringEvent);
                startDateOfRecurringShift.setHours(0, 0, 0);

                const endDateOfRecurringShift = new Date(this.endDateOfRecurringEvent);
                endDateOfRecurringShift.setHours(23, 59, 59);

                const startDateOfRecurringShiftMoment = moment(startDateOfRecurringShift);
                const endDateOfRecurringShiftMoment = moment(endDateOfRecurringShift);

                for (let startDateMoment = startDateOfRecurringShiftMoment; startDateMoment.isBefore(endDateOfRecurringShiftMoment); startDateMoment.add(1, unit)) {
                    let endDateMoment = startDateMoment;
                    endDateMoment.add(startAndEndDateTimeDifferenceInMinutes, 'minutes');

                    const startDate = startDateMoment.toDate();
                    startDate.setHours(this.startDatetime.getHours(), this.startDatetime.getMinutes(), 0);

                    const endDate = endDateMoment.toDate();
                    endDate.setHours(this.endDatetime.getHours(), this.endDatetime.getMinutes(), 0);

                    startDateMoment = moment(startDate);
                    endDateMoment = moment(endDate);

                    if (startDateMoment.isBetween(startDateOfRecurringShiftMoment, endDateOfRecurringShiftMoment) && endDateMoment.isBetween(startDateOfRecurringShiftMoment, endDateOfRecurringShiftMoment)) {
                        recurringDates.push({
                            startDate: startDate,
                            endDate: endDate
                        });
                    }
                }

                return recurringDates;
            },

            async addScheduleShiftMeeting() {
                if (this.staffSelectedForMeeting && this.staffSelectedForMeeting.length > 0) {
                    this.staffSelectedForMeeting.forEach(staff => {
                        this.saveShiftMeeting(staff);
                    });
                } else {
                    this.showErrorNotification('Please select staff for meeting.');
                }
            },

            async saveShiftMeeting(id) {
                const payload = {
                    currentUrl : window.location.href,
                    ClientId: this.ClientId,
                    EmployeeId: id,
                    HouseId: this.HouseId,
                    StartDate: this.startDatetime,
                    EndDate: this.endDatetime,
                    Notes: this.notes,
                    Task: this.task,
                    isTraining: this.isForTraining,
                    isRecurringEvent: this.isRecurringEvent,
                    typeOfRecurringEvent: this.selectedOption,
                    startDateOfRecurringEvent: this.startDateOfRecurringEvent,
                    endDateOfRecurringEvent: this.endDateOfRecurringEvent,
                };

                await axios
                    .post(`${url}/shifts/shiftMeeting`, payload)
                    .then(res => {
                        if (res) {
                            this.msg = true;
                            this.text = "Saved successfully.";
                            this.color = "success";
                            this.StaffId = 0;
                            this.staffSelectedForMeeting = "";
                            this.notes = "";
                            this.tasks = "";
                            this.task = "";
                            this.startDatetime = moment().toDate();
                            this.endDatetime = moment().add(8, 'hours').toDate();
                            let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: false}
                            this.addShift_btn_loader = false;

                            this.reset();
                            this.$emit('addSchedule', emitValue);
                        }
                    })
                    .catch(async err => {
                        if (err.response) {
                            this.text = await err.response.data.msg;
                            this.msg = true;
                            this.color = "error";
                            let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true}
                            this.addShift_btn_loader = false;

                            this.$emit('addSchedule', emitValue);
                        }
                    });

            },

            async checkRequests() {
                this.getTimeOffRequests()
            },

            async getTimeOffRequests() {
                this.timeOff = true;
                this.isLoading = true;
                await axios.get(`${url}/timeOff/approved`).then(res => {
                    this.requests = res.data.timeOffs
                }).finally(() => {
                    this.isLoading = false;
                });

            },

            async getClientsByUnit() {
                if (!this.checkShiftTimes()) {
                    this.HouseName = '';
                    this.componentKey++;
                    return;
                }

                this.ClientId = [...[]];

                this.clientsUnderSelectedProgram = [];

                await axios.get(`${url}/clients/house/${this.HouseName}`).then((res) => {
                    res.data.clients.forEach((item) => {
                        this.clientsUnderSelectedProgram.push(item);
                    });
                });

                let startDateTimeForStaff = DateTimeUtil.toUTCISOString(`${this.startShiftDate} ${this.startShiftTime}`);
                let endDatetimeForStaff = DateTimeUtil.toUTCISOString(`${this.endShiftDate} ${this.endShiftTime}`);

                await this.getHouseId();
                await this.getDefaultStaff(startDateTimeForStaff, endDatetimeForStaff);
            },


            async getHouseId() {
                await axios.get(`${url}/units`).then((res) => {
                    res.data.units.forEach((item) => {
                        if (item.Name == this.HouseName) {
                            this.HouseId = item._id;
                        }
                    });
                });
            },

            checkShiftTimes() {
                if (!this.startShiftDate) {
                    alert("Please set Start Shift Date.");
                    return false;
                }

                if (!this.endShiftDate) {
                    alert("Please set End Shift Date.");
                    return false;
                }

                return true;
            },

            // Function to check staff supervision requirement and handle selection accordingly
            checkSupervision(selectedStaff) {
                if (selectedStaff.RequiresSupervision) {
                    Swal.fire({
                        title: 'Attention!',
                        text: 'THIS STAFF REQUIRES SUPERVISION (line of sight and sound) AT ALL TIMES WHILE WORKING WITH ANY CLIENT.',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'I acknowledge',
                        cancelButtonText: 'Choose Other'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.staffSelected = selectedStaff;
                        }
                    });
                } else {
                    // No supervision required, just assign the staff
                    this.staffSelected = selectedStaff;
                }
            },



            reset(){
                this.staffSelectedForMeeting = "";
                this.StaffId = 0;
                this.ClientId = 0;
                this.HouseId = 0;
                this.HouseName = "";
                this.notes = "";
                this.startDatetime = moment().toDate();
                this.endDatetime = moment().add(8, 'hours').toDate();
                this.staffSelected = "";
                this.task = "";
                this.isRecurringEvent = "No";
                this.selectedOption = "";
                this.$v.ClientId.$reset();
                this.$v.HouseName.$reset();
                this.$refs.form.resetValidation();
                this.search = null;
            }
        }
    };
</script>
